import * as StyledComponents from './StyledComponents';
import { IPRestrictionSideSheetDetails } from './IPRestrictionSideSheetDetails';
import { IPRestrictionSideSheet } from './IPRestrictionInterface';
import FocusTrap from 'focus-trap-react';

export const IPRestrictionSideSheetBody = ({
  model,
  onSave,
  onCancel,
}: IPRestrictionSideSheet): JSX.Element => {
  return (
        <FocusTrap active={true}
        focusTrapOptions={{
          clickOutsideDeactivates: true,
                        tabbableOptions: {
                            displayCheck: 'none'
                        }
                    }}>
    <StyledComponents.StyledSideSheetBodyContainer>
      <IPRestrictionSideSheetDetails
        model={model}
        onSave={onSave}
        onCancel={onCancel}
      />
    </StyledComponents.StyledSideSheetBodyContainer>
    </FocusTrap>
  );
};
